<template lang="pug">
  
  v-navigation-drawer(v-model="visible" app floating clipped :disable-resize-watcher="true")
    v-list(dense)
      v-list-item(v-for="name, route in routes.main" :key="route" :to="route" @click="visible=false")
        v-list-item-content {{ name }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data() {
    return {
      visible: false
    }
  },

  computed: {
    ...mapGetters('auth', [
      'routes',
    ]),
  },
}
</script>